import z from "zod";
import { LabelIdSchema, LabelSchema } from "@storytell/types";

export const LabelIdParamsSchema = z.object({
  id: z.string(),
});

export const CreateLabelInputSchema = LabelSchema.pick({
  name: true,
  description: true,
  icon: true,
  color: true,
});
export type CreateLabelInput = z.infer<typeof CreateLabelInputSchema>;

export const UpdateLabelInputSchema = LabelSchema.pick({
  name: true,
  description: true,
  icon: true,
  color: true,
});
export type UpdateLabelInput = z.infer<typeof UpdateLabelInputSchema>;

// Sync endpoint returns a map of label IDs to label objects
export const LabelsSyncSchema = z.object({
  labels: z.record(LabelIdSchema, LabelSchema),
});
export type LabelsSync = z.infer<typeof LabelsSyncSchema>;

// Label association schemas
export const AssociateLabelInputSchema = z.object({
  labelId: z.string(),
  resourceId: z.string(),
  resourceType: z.string(),
});
export type AssociateLabelInput = z.infer<typeof AssociateLabelInputSchema>;

export const DisassociateLabelInputSchema = z.object({
  associationId: z.string(),
});
export type DisassociateLabelInput = z.infer<typeof DisassociateLabelInputSchema>;

export const LabelAssociationSchema = z.object({
  id: z.string(),
  labelId: z.string(),
  resourceId: z.string(),
  resourceType: z.string(),
  tenantId: z.string(),
  createdBy: z.string(),
  createdAt: z.string(),
  modifiedBy: z.string(),
  modifiedAt: z.string(),
});
export type LabelAssociation = z.infer<typeof LabelAssociationSchema>;

export const AssociateLabelResponseSchema = z.array(LabelAssociationSchema);
export type AssociateLabelResponse = z.infer<typeof AssociateLabelResponseSchema>;

// Bulk operation schemas (arrays of the above)
export const BulkAssociateLabelInputSchema = z.array(AssociateLabelInputSchema);
export type BulkAssociateLabelInput = z.infer<typeof BulkAssociateLabelInputSchema>;

export const BulkDisassociateLabelInputSchema = z.array(DisassociateLabelInputSchema);
export type BulkDisassociateLabelInput = z.infer<typeof BulkDisassociateLabelInputSchema>;

export const LabelAssociationsSyncSchema = z.array(LabelAssociationSchema);
export type LabelAssociationsSync = z.infer<typeof LabelAssociationsSyncSchema>;
